import React, { useState } from 'react';
import classNames from 'classnames';
import styles from '../assets/case-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { CellProps } from 'react-table';

import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';

import { ICaseNoPrincipal } from 'src/types/caseNoPrincipal';

import user from '../../../../../../services/user-auth';
import UserRole from '../../../../../../enumerables/user-role';
import { ICase } from '../../../../../../types/case';
import { changeToZeroMoment } from '../../../../../../helpers/timeHelpers';
import dropdownFilter from '../../../../../../components/react-table/filters/dropdown-filter';

interface Props {
    data: Paginated<ICaseNoPrincipal>;
    students: SelectObject[];
    districts: SelectObject[];
    providers: SelectObject[];
    vendors: SelectObject[];
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
}

/*const typeEnum = CaseEnum ? CaseEnum.getEnum('caseType') : {};
const caseTypes: SelectObject[] = getValFromEnum(typeEnum);

const typeOrderEnum = OrderEnum ? OrderEnum.getEnum('OrderType') : {};
const orderTypes: SelectObject[] = getValFromEnum(typeOrderEnum);*/

const getColumns = (
    dataStud: SelectObject[],
    districts: SelectObject[],
    vendors: SelectObject[],
    providers: SelectObject[],
): Column<ICaseNoPrincipal>[] => [
    {
        Header: '#',
        accessor: 'id',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICaseNoPrincipal>) => (
            <Link className={'btn btn-info'} to={Router.generate(routes.CASE_EDIT, { id: original.id })}>
                {original.id}
            </Link>
        ),
        Filter: textFilter<ICaseNoPrincipal>(),
    },
    {
        Header: 'Case Number',
        accessor: 'caseNumber',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICaseNoPrincipal>) => (
            <Link
                to={Router.generate(routes.CASE_EDIT, {
                    id: original?.id,
                })}
            >
                {original.caseNumber}
            </Link>
        ),
        Filter: textFilter<ICaseNoPrincipal>(),
    },
    {
        Header: 'Student',
        accessor: 'student.id',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICaseNoPrincipal>) => {
            if (!original?.student) return '';
            if (user.getRoles().includes(UserRole.ROLE_ADMIN)) {
                return (
                    <Link
                        to={Router.generate(routes.STUDENT_DETAIL, {
                            id: original?.student?.id,
                            tab: 'student-info',
                        })}
                    >
                        {`${original.student?.firstName} ${original.student?.lastName}`}
                    </Link>
                );
            }
            return `${original.student?.firstName} ${original.student?.lastName}`;
        },
    },
    {
        Header: 'Provider',
        accessor: 'occasionProviders.provider',
        disableSortBy: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            const valueProvider: string[] = [];
            original.occasionProviders.forEach((itP: any) => {
                if (itP.provider) {
                    valueProvider.push(
                        `${itP.provider?.fullName} - ( from ${changeToZeroMoment(itP.createdAt, 'MMM D, YYYY')} )`,
                    );
                }
            });
            return valueProvider.join(',');
        },

        Filter: dropdownFilter<ICase>(providers),
    },
    {
        Header: 'Service Type',
        accessor: 'serviceType',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICaseNoPrincipal>) => {
            let title = original?.serviceType?.title;
            if (!title) {
                title = original?.serviceType?.cpt;
            }

            return <div>{title}</div>;
        },
        Filter: textFilter<ICaseNoPrincipal>(),
    },
];

const CasesGrid: React.FunctionComponent<Props> = ({
    data,
    getData,
    students,
    districts,
    providers,
    vendors,
    getDataCsv,
}: Props) => {
    const [columns, setColumns] = useState<any>([]);

    if (students.length && !columns.length) {
        setColumns(getColumns(students, districts, vendors, providers));
    }
    return (
        <div className={classNames(styles.grid)}>
            <Grid<ICaseNoPrincipal> columns={columns} getDataCsv={getDataCsv} data={data} getData={getData} />
        </div>
    );
};

export default CasesGrid;
